import {createAction, props} from '@ngrx/store';
import {ICategoryListRequestModel} from '../models/category-list-request.model';
import {ICategoryListResponseModel} from '../models/category-list-response.model';

export enum CategoryListActions {
  CategoryList = '[CategoryList Component] CategoryList',
  CategoryListSuccess = '[CategoryList Effects] CategoryList Success',
  CategoryListFailure = '[CategoryList Effects] CategoryList Failure',
  CategoryListError = '[CategoryList Effects] CategoryList Error',
  ResetCategoryList = '[CategoryList Effects] CategoryList Reset',
}

export const categoryListAction = createAction(
  CategoryListActions.CategoryList,
  props<{request: ICategoryListRequestModel}>()
);
export const categoryListEffectSuccess = createAction(
  CategoryListActions.CategoryListSuccess,
  props<{response: ICategoryListResponseModel[]}>()
);
export const categoryListEffectFailure = createAction(
  CategoryListActions.CategoryListFailure,
  props<{reason: string}>()
);
export const categoryListEffectError = createAction(CategoryListActions.CategoryListError, props<{error: string}>());
export const resetCategoryList = createAction(CategoryListActions.ResetCategoryList);
